export enum SaveResult {
  succeeded,
  failed,
}

export default interface PostState {
  isPosting: boolean;
  postResult: SaveResult | null;
}

export function post(postState?: PostState): PostState {
  if (postState && postState.isPosting) {
    throw Error('Already posting!');
  }

  return { isPosting: true, postResult: null };
}

export function completePost(postState?: PostState): PostState {
  if (postState && !postState.isPosting) {
    throw Error('Can not complete post if it is not in progress!');
  }

  return { isPosting: false, postResult: SaveResult.succeeded };
}

export function failPost(postState?: PostState): PostState {
  if (postState && !postState.isPosting) {
    throw Error('Can not complete post if it is not in progress!');
  }

  return { isPosting: false, postResult: SaveResult.failed };
}
